import get_title from "@/router/module/get_title";
import NomenclatureModelRouterHook from "@/new/auth/nomenclature-model.router-hook";

export default {
  path: "/content/nomenclature/:productId/images",
  name: "product-edit__images",
  meta: {
    title: get_title("Товар | Изображения"),
    forVisitors: true,
    requiresAuth: true
  },
  component: () => import("@/new/pages/nomenclature/edit/images.vue"),
  beforeEnter: NomenclatureModelRouterHook("product.show-images"),
};
